import { render } from "./buttonEnat.vue?vue&type=template&id=ffe74e44&scoped=true"
import script from "./buttonEnat.vue?vue&type=script&lang=js"
export * from "./buttonEnat.vue?vue&type=script&lang=js"

import "./buttonEnat.vue?vue&type=style&index=0&id=ffe74e44&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffe74e44"]])

export default __exports__